import { STANDARD_BRANCH } from '@festina-life/api'
import { useMemo } from 'react'

import { DraftIndicator } from '../../components/draftIndicator/DraftIndicator'
import { OperationApproval } from '../../components/operationApproval/OperationApproval'
import { OperationViewerTopBar } from '../../components/operationViewerTopBar/OperationViewerTopBar'
import { useNavigationParams } from '../../system/useNavigationParams'
import { useRegisteredTenant } from '../../system/useRegisteredTenant'
import { useApplicationViewOperationsContext } from '../../workspace/applicationViewOperationsContext'
import { TenantTransferButton } from './TenantTransferButton'

export const TenantViewerTopBar = () => {
  const currentTenantRegistrationId = useRegisteredTenant()
  const { branch } = useNavigationParams()
  const { applicationRegisteredTenants } = useApplicationViewOperationsContext()

  const registeredTenantOperation = useMemo(
    () =>
      applicationRegisteredTenants.find(
        (operation) =>
          operation.internalOperation.registeredTenant?.tenantId ===
          currentTenantRegistrationId,
      ),
    [applicationRegisteredTenants, currentTenantRegistrationId],
  )

  const isDraft = registeredTenantOperation?.isDraft
  const changesetKey = registeredTenantOperation?.changesetHistory?.changesetKey
  const operationKey = registeredTenantOperation?.internalOperation.operationKey

  const isRenderingApproval =
    !isDraft && branch !== STANDARD_BRANCH && changesetKey && operationKey

  return (
    <OperationViewerTopBar className="justify-end gap-x-2 mb-3">
      {isDraft && <DraftIndicator />}
      {isRenderingApproval && (
        <OperationApproval
          actions={registeredTenantOperation?.actions ?? []}
          changesetKey={changesetKey}
          operationKey={operationKey}
        />
      )}
      <TenantTransferButton />
    </OperationViewerTopBar>
  )
}
